module.exports = __webpack_public_path__ + "img/compentation_experience.48dc962c.svg";